var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Confirm", {
    ref: "confirmRef",
    attrs: { "max-width": _vm.maxWidth },
    scopedSlots: _vm._u([
      {
        key: "card-title",
        fn: function (ref) {
          var close = ref.close
          return [
            _c("v-card-title", { staticClass: "alert-dialog__header" }, [
              _c(
                "div",
                { staticClass: "alert-dialog__header-inner" },
                [
                  _c("span", { staticClass: "text-h6 alert-dialog__title" }, [
                    _vm._v(_vm._s(_vm.$t("title"))),
                  ]),
                  _c(
                    "v-btn",
                    {
                      staticClass: "alert-dialog__close",
                      attrs: { depressed: "", icon: "" },
                      on: { click: close },
                    },
                    [
                      _c("v-icon", { attrs: { size: "18" } }, [
                        _vm._v("close"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        },
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("p", { staticClass: "mb-2 text-body-2" }, [
              _vm._v(_vm._s(_vm.$t("msg[0]"))),
            ]),
            _c("p", { staticClass: "mt-0 mb-4 text-body-2" }, [
              _vm._v(_vm._s(_vm.$t("msg[1]"))),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function (ref) {
          var close = ref.close
          return [
            _c(
              "v-btn",
              {
                staticClass: "text-none",
                attrs: { depressed: "", text: "", color: "primary" },
                on: { click: close },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("btn_maybe_later")) + "\n    "
                ),
              ]
            ),
            _c("v-spacer"),
            _vm.hasVerificationEnabled
              ? _c(
                  "v-btn",
                  {
                    staticClass: "text-none",
                    attrs: {
                      depressed: "",
                      color: "primary",
                      to: "/account/verify-info",
                    },
                    on: { click: close },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("btn_complete_verification")) +
                        "\n    "
                    ),
                  ]
                )
              : !_vm.checkInfoCompleted()
              ? _c(
                  "v-btn",
                  {
                    staticClass: "text-none",
                    attrs: {
                      depressed: "",
                      color: "primary",
                      to: "/account/information",
                    },
                    on: { click: close },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("btn_complete_account_info")) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }